<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.outer-connect-mng')" />
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card no-body>
          <b-card-body>
            <div class="float-left float-none-xs">
              <div class="d-inline-block">
                <h5 class="d-inline">카카오톡 예약하기</h5>
                <span class="text-muted d-block mt-1">하이테이블에서 카카오톡 예약하기 입점부터 예약 주문과 상품까지 한번에 관리해보세요.</span>
              </div>
            </div>
            <b-button v-if="showToggle" class="float-right float-none-xs" variant="primary" @click="goToKakaoChennelReg">입점신청</b-button>
          </b-card-body>
          <kakao-chennel-list class="card-body pt-0" @get-list="getListData"></kakao-chennel-list>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
  mapGetters,
  mapActions
} from "vuex";
import {
  Chrome,
  Swatches
} from 'vue-color';
import ModalPostcode from "../shop/components/ModalPostcode.vue";
import ModalImage from '../shop/components/ModalImage';
import KakaoChennelList from "../booking/components/KakaoChennelList.vue";
import api from '../../constants/api';


export default {
  name: "OuterConnectMng",
  components: {
    Chrome,
    Swatches,
    'v-select': vSelect,
    'modal_postcode': ModalPostcode,
    'modal_image': ModalImage,
    KakaoChennelList
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName','info'])
  },
  data(){
    return{
      listData:[],
      showToggle : false,
      storeCode : "",
      storeStatus : false




    }
  },
  created() {
    if(this.currentUser.userRole !=="BRAND_ADMIN"){
      this.setStore()
    }

  },
  mounted() {



  },
  methods:{
    goToKakaoChennelReg(){
      let brandInfo = JSON.parse(sessionStorage.getItem("BRAND_INFO"))

      console.log(this.currentUser.userRole)
      console.log(brandInfo)

      if(this.currentUser.userRole =="BRAND_ADMIN"){
        this.$router.push(`/${this.siteName}/booking/kakao-chennel-reg`);
      }else{
        if(!this.enable){
          alert("매장이 전시중인 경우만 신청 가능합니다.\n" +
              "[매장 관리 > 매장 리스트 > 상세 > 전시관리]에서\n" +
              "전시여부를 “전시함”으로 변경해 주세요.");
        }else{
          this.$router.push(`/${this.siteName}/booking/kakao-chennel-reg`);
        }

      }

    },
    getListData(val){
      let brandInfo = JSON.parse(sessionStorage.getItem("BRAND_INFO"))
      this.storeCode = sessionStorage.getItem("storeCode") =='null' ? '' : sessionStorage.getItem("storeCode")
      this.listData = val
      console.log(this.listData)
      if(this.currentUser.userRole =="BRAND_ADMIN"){
        this.showToggle = true
      }else{
        if(!this.listData.length){
          this.showToggle = true
        }else {
          this.showToggle = false;
        }
        console.log(this.storeCode)
      }

    },
    setStore() {
      const reqUrl = api.changeAPI(this.siteName, api.basicURL + api.shop.basicInfoStr)

      this.$http.get(reqUrl, {
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          const data = res.data.data
          console.log(data)
          this.enable = data.enabled
          this.bookingInfo.selectedStore = data.storeCode
          this.bookingInfo.selectedStoreName = res.data.data.basicInfo.storeName
        } else {
          throw 400
        }
      }).catch(err => {
        alert(err.response.data.message);
      })
    },


  }
}
</script>

<style scoped>
.testClass{
  background-color: #000000;
  opacity: 0.5;
  overflow: scroll;
}

</style>
